export const basicProgressData = [
    {
      text: "Progress components are built with two HTML elements, some CSS to set the width, and a few attributes. We use the ",
      code: ".progress ",
    },
    {
      text: "as a wrapper to indicate the max value of the progress bar. The ",
      code: ".progress-bar ",
    },
    {
      text: "requires an inline style, utility class, or custom CSS to set their width.",
    },
  ];
  
  export const basicProgressList = [
    {
      color: "primary",
      value: "25",
      text: "25%",
    },
    {
      color: "secondary",
      value: "50",
      text: "50%",
    },
    {
      color: "success",
      value: "75",
      text: "75%",
    },
    {
      color: "info",
      value: "100",
      text: "100%",
    },
  ];
  
  export const progressStripData = [
    {
      text: "Add ",
      code: ".progress-bar-striped",
    },
    {
      text: " to any ",
      code: ".progress-bar ",
    },
    {
      text: "to apply a stripe via CSS gradient over the progress bar's background color Using CSS Effects.",
    },
  ];
  
  export const progressStripList = [
    {
      color: "warning",
      value: "25",
    },
    {
      color: "danger",
      value: "50",
    },
    {
      color: "success",
      value: "75",
    },
  ];
  
  export const animatedData = [
    {
      text: "The striped gradient can also be animated. Add ",
      code: ".progress-bar-animated",
    },
    {
      text: " to",
      code: ".progress-bar",
    },
    {
      text: " to animate the stripes right to left via CSS3 animations.",
    },
  ];
  
  export const animatedList = [
    {
      color: "warning",
      value: "25",
    },
    {
      color: "danger",
      value: "50",
    },
    {
      color: "success",
      value: "75",
    },
  ];
  
  export const multipleDta = [
    {
      text: "Include multiple progress bars in a progress component if you need.",
    },
  ];
  
  export const multipleList = [
    {
      color: "primary",
      value: "10",
    },
    {
      color: "secondary",
      value: "10",
    },
    {
      color: "success",
      value: "10",
    },
    {
      color: "info",
      value: "10",
    },
    {
      color: "warning",
      value: "10",
    },
    {
      color: "danger",
      value: "10",
    },
    {
      color: "primary",
      value: "10",
    },
    {
      color: "light",
      value: "10",
    },
  ];
  
  export const progressNumberData = [
    {
      text: "Use the ",
      code: ".position-absolute",
    },
    {
      text: " to set progress numbers steps.",
    },
  ];
  
  export const progressNumberList = [
    {
      color: "primary",
      number: "2",
      className: "start-50 txt-light",
    },
    {
      color: "transparent",
      number: "3",
      className: "progress-btn start-100 txt-dark",
    },
  ];
  
  export const customProgressData = [
    {
      text: "Use the ",
      code: ".progress-bar-animated ",
    },
    {
      text: "and ",
      code: ".progress-bar-striped ",
    },
    {
      text: "to animate the stripes right to left.",
    },
  ];
  
  export const customProgressList = [
    {
      title: "30% Getting Uploading...",
      color: "primary",
      value: "30",
      text: "30%",
    },
    {
      title: "60% Getting Uploading...",
      color: "secondary",
      value: "60",
      text: "60%",
    },
    {
      title: "70% Getting Uploading...",
      color: "success",
      value: "70",
      text: "70%",
    },
    {
      title: "100% Getting Uploading...",
      color: "dark",
      value: "100",
      text: "100%",
    },
  ];
  
  export const smallProgressData = [
    {
      text: "Use ",
      code: " .sm-progress-bar",
    },
    {
      text: " class to change progress size to small:",
    },
  ];
  
  export const smallProgressList = [
    {
      title: "50 MB Data",
      value: "50",
    },
    {
      title: "75 MB Data",
      value: "75",
    },
    {
      title: "90 MB Data",
      value: "90",
    },
  ];
  
  export const largeProgressData = [
    {
      text: "Use ",
      code: " .lg-progress-bar",
    },
    {
      text: " class to change progress size to large:",
    },
  ];
  
  export const largeProgressList = [
    {
      color: "secondary",
      text: "50%",
      value: "50",
    },
    {
      color: "success",
      text: "75%",
      value: "75",
    },
    {
      color: "info",
      text: "10%",
      value: "100",
    },
  ];
  
  export const heightProgressData = [
    {
      text: "Set a height value on the ",
      code: ".progress-bar",
    },
    {
      text: ", so if you change that value the outer",
      code: ".progress",
    },
    {
      text: " will automatically resize accordingly.",
    },
  ];
  
  export const heightProgressList = [
    {
      color: "warning",
      height: "5px",
      value: "50",
    },
    {
      color: "danger",
      height: "11px",
      value: "75",
    },
    {
      color: "info",
      height: "19px",
      value: "100",
    },
  ];